import { path } from 'chromedriver'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const errer = () => import('@/components/public/errer.vue') // 404
/** ***********/
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      // 首页
      path: '/',
      name: 'index',
      component: () => import('@/views/index/index')
    },
    // {
    //   path: '/index/dd',
    //   name: 'ddd',
    //   component: () => import('@/views/index/dd')
    // },
    {
      path: '/index/ask',
      name: 'ask',
      component: () => import('@/views/index/ask'),
      children: [
        {
          //首页搜索
          path: "search",
          component: () => import('@/views/index/search')
        },
        {
          //首页搜索列表
          path: "searchDatael",
          component: () => import('@/views/index/searchDatael')
        },
        {
          // 签到
          path: "signDay",
          component: () => import('@/views/index/signDay')
        }
      ]
    },
    /****************讨论/discuss/talk****************/
    {
      path: '/discuss/talk',
      name: 'talk',
      component: () => import('@/views/discuss/talk'),
      children: [
        //讨论首页
        {
          path: "home",
          component: () => import('@/views/discuss/home')
        },
        //查看热议讨论
        {
          path: "listDateil",
          component: () => import('@/views/discuss/listdateil')
        },
        //讨论详情
        {
          path: "dissDetail",
          component: () => import('@/views/discuss/dissDetail')
        },
        //老师发表评论
        {
          path: "commTeacher",
          component: () => import('@/views/discuss/commteacher')
        },
        //话题老师主页
        {
          path: "dissMaster",
          component: () => import('@/views/discuss/dissmaster')
        },
        //话筒老师海报
        {
          path: "dissPoster",
          component: () => import('@/views/discuss/dissposter')
        },
        //老师卖货订单支付成功返回
        {
          path: "dissPaysuccess",
          component: () => import('@/views/discuss/dipaysuccessssposter')
        },
      ]
    },

    /*********文章/article/essay**********/
    {
      path: '/article/essay',
      name: 'essay',
      component: () => import('@/views/article/essay'),
      children: [
        //文章首页
        {
          path: "home",
          component: () => import('@/views/article/home')
        },
        //未来知识
        {
          path: "getallclass",
          component: () => import('@/views/article/getallclass')
        },
        //文章上新-帮帮讲堂
        {
          path: "getallarticle",
          component: () => import('@/views/article/getallarticle')
        },
        //讲堂大咖
        {
          path: "masterList",
          component: () => import('@/views/article/masterList')
        },
        //热门标签
        {
          path: "hotLabel",
          component: () => import('@/views/article/hotLabel')
        },
        //数术详情
        {
          path: "fewDetail",
          component: () => import('@/views/article/fewDetail')
        },
        //文章详情
        {
          path: "essayDetail",
          component: () => import('@/views/article/essayDetail')
        },
        //评论页面
        {
          path: "commentArticle",
          component: () => import('@/views/article/commentArticle')
        },
      ]
    },

    /*********闪测/discover/flash**********/
    {
      path: "/discover/flash",
      name: 'flash',
      component: () => import('@/views/discover/flash'),
      children: [
        {
          //闪测首页
          path: "home",
          component: () => import('@/views/discover/home')
        },
        {
          //闪测详情
          path: "quickDetail",
          component: () => import('@/views/discover/quickDetail')
        },
        {
          //用户热评
          path: "quickcomment",
          component: () => import('@/views/discover/quickcomment')
        },
        {
          //每日一测
          path: "quickToday",
          component: () => import('@/views/discover/quickToday')
        },
        {
          //闪测推荐
          path: "quickSubject",
          component: () => import('@/views/discover/quickSubject')
        },
        {
          //闪测主题详情页
          path: "quicksubjectdetail",
          component: () => import('@/views/discover/quicksubjectdetail')
        },
        {
          //全部闪测
          path: "quicklist",
          component: () => import('@/views/discover/quicklist')
        },
        {
          //心理测评专题列表页
          path: "xinliSubject",
          component: () => import('@/views/discover/xinliSubject')
        },
        {
          //心理测评详情
          path: "xinlidetail",
          component: () => import('@/views/discover/xinlidetail')
        },
        // -------------------------------
        {
          //测评专题详情页
          path: "xinliSubjectDetail",
          component: () => import('@/views/discover/xinliSubjectDetail')
        },
        {
          //全部测评页
          path: "xinliList",
          component: () => import('@/views/discover/xinliList')
        },
        {
          //闪测主题页
          path: "themes",
          component: () => import('@/views/discover/themes')
        },
      ]
    },

    /*********广场/square/ask**********/
    {
      path: "/square/ask",
      name: 'ask',
      component: () => import('@/views/square/ask'),
      children: [
        {
          //广场首页
          path: "home",
          component: () => import('@/views/square/home')
        },
        {
          //问答详情
          path: "askresult",
          component: () => import('@/views/square/askresult')
        },
        {
          //闪测搜索
          path: "asksearch",
          component: () => import('@/views/square/asksearch')
        },
        {
          //闪测搜索结果
          path: "asksearchDatael",
          component: () => import('@/views/square/asksearchDatael')
        },
        {
          //快速提问
          path: "question",
          component: () => import('@/views/square/question')
        },
        {
          //选择老师
          path: "result",
          component: () => import('@/views/square/result')
        },
        {
          //闪测选择优惠劵
          path: "select_coupon",
          component: () => import('@/views/square/select_coupon')
        },
        {
          //填写信息
          path: "answerPaysuccess",
          component: () => import('@/views/square/answerPaysuccess')
        },
        {
          //问题详情
          path: "answerDetail",
          component: () => import('@/views/square/answerDetail')
        },
        {
          //订单评价
          path: "answerComment",
          component: () => import('@/views/square/answerComment')
        },
        {
          //订单评价-成功
          path: "answerComsucces",
          component: () => import('@/views/square/answerComsucces')
        },
        {
          //查看评论
          path: "answerCommentDetail",
          component: () => import('@/views/square/answerCommentDetail')
        },
        {
          //修改评论
          path: "answerCommentEdit",
          component: () => import('@/views/square/answerCommentEdit')
        },
        {
          //追问
          path: "answerKing",
          component: () => import('@/views/square/answerKing')
        },
        {
          //详测选择优惠劵
          path: "survey_coupon",
          component: () => import('@/views/square/survey_coupon')
        },
        {
          //详测支付成功
          path: "survey_paysuccess",
          component: () => import('@/views/square/survey_paysuccess')
        },
        {
          //评测评论-查看评论
          path: "XinliComment",
          component: () => import('@/views/square/XinliComment')
        },
        {
          //评测查看报告与开始答题
          path: "xinli_dialog",
          component: () => import('@/views/square/xinli_dialog')
        },
        {
          //评测选择优惠劵
          path: "xinli_select_coupon",
          component: () => import('@/views/square/xinli_select_coupon')
        },
        {
          // 评测支付成功页面
          path: "xinli_paysuccess",
          component: () => import('@/views/square/xinli_paysuccess')
        },
        {
          //详测-订单评价
          path: "commentAdd",
          component: () => import('@/views/square/commentAdd')
        },
        {
          //详测-订单评价-成功
          path: "commentOk",
          component: () => import('@/views/square/commentOk')
        },
        {
          //详测-查看评价
          path: "commentDetail",
          component: () => import('@/views/square/commentDetail')
        },
        {
          //详测-修改评价
          path: "commentEdit",
          component: () => import('@/views/square/commentEdit')
        },
        {
          //调理建议
          path: "goodsIndex",
          component: () => import('@/views/square/goodsIndex')
        },
      ]
    },
    /****************确定订单****************/
    {
      path: "/order/module",
      name: 'module',
      component: () => import('@/views/order/module'),
      children: [
        {
          //闪测确定订单
          path: "answerConfirm",
          component: () => import('@/views/order/answerConfirm')
        },
        {
          //详测确认订单
          path: "surveyConfirm",
          component: () => import('@/views/order/surveyConfirm')
        },
        {
          //评测确定订单
          path: "xinliConfirm",
          component: () => import('@/views/order/xinliConfirm')
        },
        {
          //课程确定订单
          path: "classConfirm",
          component: () => import('@/views/order/classConfirm')
        },
      ]
    },
    /****************意见反馈****************/
    {
      //闪测
      path: '/feedback',
      name: 'publicfeedback',
      component: () => import('@/components/public/feedback.vue')
    },
    /****************登录注册****************/
    {
      //登录
      path: '/login',
      name: 'loginIndex',
      component: () => import('@/components/public/login.vue')
    },
    //注册
    {
      path: '/registration',
      name: 'regIstration',
      component: () => import('@/components/public/registration.vue')
    },
    //区号
    {
      path: '/areacode',
      name: 'areaCode',
      component: () => import('@/components/public/areaCode.vue')
    },

    /******************老师主页/teacher/master******************/
    {
      path: '/teacher/master',
      name: 'master',
      component: () => import('@/views/teacher/master'),
      children: [
        //老师主页
        {
          path: "home",
          component: () => import('@/views/teacher/home')
        },
        //全部评论
        {
          path: "commentDateil",
          component: () => import('@/views/teacher/commentDateil')
        },
        //专栏
        {
          path: "setIndex",
          component: () => import('@/views/teacher/setIndex')
        },
        {
          //示例服务
          path: "dialogExam",
          component: () => import('@/views/teacher/dialogExam')
        },
      ]
    },

    /******************咨询/seek/consult**********************/
    {
      path: '/seek/consult',
      name: 'consult',
      component: () => import('@/views/seek/consult'),
      children: [
        //首页
        {
          path: "home",
          component: () => import('@/views/seek/home')
        },
        //新师力
        {
          path: "newTeacher",
          component: () => import('@/views/seek/newTeacher')
        },
        //名师团
        {
          path: "famousTeacher",
          component: () => import('@/views/seek/famousTeacher')
        },
        //月票榜
        {
          path: "monthTicket",
          component: () => import('@/views/seek/monthTicket')
        },
        //全部评价
        {
          path: "consultAssess",
          component: () => import('@/views/seek/consultAssess')
        },
        //全部老师
        {
          path: "teacherIndex",
          component: () => import('@/views/seek/teacherIndex')
        },
        //搜索
        {
          path: "searchMaster",
          component: () => import('@/views/seek/searchMaster')
        },
        //全部分类
        {
          path: "category",
          component: () => import('@/views/seek/category')
        },
        // 为您智能推荐专属老师
        {
          path: "dialog",
          component: () => import('@/views/seek/dialog')
        },
        //智能匹配结果
        {
          path: "matching",
          component: () => import('@/views/seek/matching')
        },

      ]
    },

    /******************老师个人中心/master/center**********************/
    {
      path: "/master/center",
      name: "center",
      component: () => import('@/views/master/center'),
      children: [
        {
          //首页
          path: 'home',
          component: () => import('@/views/master/home')
        },
        {
          // 老师升级
          path: 'upgrade',
          component: () => import('@/views/master/upgrade')
        },
        {
          // 查看违规条例
          path: "violationDetail",
          component: () => import('@/views/master/violationDetail')
        },
        {
          // 升级说明
          path: "remark",
          component: () => import('@/views/master/remark')
        },
        {
          //开始答题
          path: "answerList",
          component: () => import('@/views/master/answerList')
        },
        {
          //答题中
          path: "answerDetail",
          component: () => import('@/views/master/answerDetail')
        },
        {
          // 答题完成
          path: "answerTimeEnd",
          component: () => import('@/views/master/answerTimeEnd')
        },
        {
          //我的积分
          path: "pointindex",
          component: () => import('@/views/master/pointindex')
        },
        {
          //积分规则
          path: "pointRule",
          component: () => import('@/views/master/pointRule')
        },
        {
          //积分明细
          path: "pointDetail",
          component: () => import('@/views/master/pointDetail')
        },
        {
          // 老师端我的订单
          path: "order",
          component: () => import('@/views/master/order')
        },
        {
          //老师端我的订单 测算记录
          path: "orderList",
          component: () => import('@/views/master/orderList')
        },
        {
          //老师端我的订单 标签编辑
          path: "orderEditlabel",
          component: () => import('@/views/master/orderEditlabel')
        },
        {
          //老师端我的订单 搜索订单
          path: "orderSearch",
          component: () => import('@/views/master/orderSearch')
        },
        {
          //预约记录 我的预约
          path: "record",
          component: () => import('@/views/master/record')
        },
        {
          //老师端 我的闪测订单
          path: "quick",
          component: () => import('@/views/master/quick')
        },
        {
          //老师端 问答回复
          path: "quickList",
          component: () => import('@/views/master/quickList')
        },
        {
          //老师端 老师公告
          path: "noticeIndex",
          component: () => import('@/views/master/noticeIndex')
        },
        {
          //老师端 老师公告-搜索
          path: "noticeSearch",
          component: () => import('@/views/master/noticeSearch')
        },
        {
          //老师端 老师公告-详情
          path: "noticeDetail",
          component: () => import('@/views/master/noticeDetail')
        },
        {
          //我的收入
          path: "incomeIndex",
          component: () => import('@/views/master/incomeIndex')
        },
        {
          // 我的收入 闪测结算说明
          path: "incomeRemark",
          component: () => import('@/views/master/incomeRemark')
        },
        {
          // 我的月票
          path: "monthticket",
          component: () => import('@/views/master/monthticket')
        },
        {
          //接单数设置
          path: "orderNum",
          component: () => import('@/views/master/orderNum')
        },
        {
          //快捷回复
          path: "replyIndex",
          component: () => import('@/views/master/replyIndex')
        },
        {
          //快捷回复-添加
          path: "replyAdd",
          component: () => import('@/views/master/replyAdd')
        },
        {
          //快捷回复-编辑
          path: "replyEdit",
          component: () => import('@/views/master/replyEdit')
        },
        {
          //推广合作
          path: "promotion",
          component: () => import('@/views/master/promotion')
        },
        {
          //推广合作收益详情
          path: "promotionDetail",
          component: () => import('@/views/master/promotionDetail')
        },
        {
          //推荐入驻-邀请好友
          path: "shareIndex",
          component: () => import('@/views/master/shareIndex')
        },
        {
          //老师叮嘱
          path: "getmasterlist",
          component: () => import('@/views/master/getmasterlist')
        },
        {
          //老师叮嘱-添加与修改
          path: "getmasterSetExhort",
          component: () => import('@/views/master/getmasterSetExhort')
        },
        {
          //我的投稿
          path: "myarticle",
          component: () => import('@/views/master/myarticle')
        },
        {
          //我的投稿-确定-修改投稿
          path: "myarticleDetail",
          component: () => import('@/views/master/myarticleDetail')
        }
      ]
    },

    /*************************************/
    {
      // 404
      path: '/errer',
      component: errer
    },
    {
      // 发票助手页
      path: '/invoice',
      name: 'InvoiceHome',
      component: () => import('@/views/invoice/home')
    },
    {
      // 开发票
      path: '/invoice/start',
      name: 'InvoiceStart',
      component: () => import('@/views/invoice/start')
    },
    {
      // 提交开票信息
      path: '/invoice/form',
      name: 'InvoiceFrom',
      component: () => import('@/views/invoice/form')
    },
    {
      // 开票规则
      path: '/invoice/rule',
      name: 'InvoiceRule',
      component: () => import('@/views/invoice/rule')
    },
    {
      // 查看订单
      path: '/invoice/order',
      name: 'InvoiceOrder',
      component: () => import('@/views/invoice/order')
    },
    {
      // 开票信息提交状态
      path: '/invoice/startList',
      name: 'InvoiceStartList',
      component: () => import('@/views/invoice/startList')
    },
    {
      // 开票信息详情
      path: '/invoice/details',
      name: 'InvoiceDetails',
      component: () => import('@/views/invoice/details')
    },
    {
      // 开票信息详情-开票历史
      path: '/invoice/makeHist',
      name: 'InvoiceMakeHist',
      component: () => import('@/views/invoice/makeHist')
    },
    {
      // 下载电子票
      path: '/invoice/makeDown',
      name: 'InvoiceMakeDown',
      component: () => import('@/views/invoice/makeDown')
    },
    // **********
    {
      // 企业专票
      path: '/invoice/companyTick',
      name: 'InvoiceCompanyTick',
      component: () => import('@/views/invoice/companyTick')
    },
    {
      // 企业专票提交
      path: '/invoice/companySubmit',
      name: 'InvoiceCompanySubmit',
      component: () => import('@/views/invoice/companySubmit')
    },
    {
      // 企业专票详情
      path: '/invoice/companyDetails',
      name: 'InvoiceCompanyDetails',
      component: () => import('@/views/invoice/companyDetails')
    },
    {
      // 普票-企业-专票抬头
      path: '/invoice/ticket',
      name: 'InvoiceTicket',
      component: () => import('@/views/invoice/ticket')
    },
    {
      // 添加【普票-企业-专票】抬头
      path: '/invoice/addTicket',
      name: 'InvoiceAddTicket',
      component: () => import('@/views/invoice/addTicket')
    },
    // -------------------- 每日运势 -------------------------
    {
      // 每日运势首页
      path: '/fortune/home',
      name: 'FortuneHome',
      component: () => import('@/views/fortune/home')
    },
    {
      // 每日运势
      path: '/fortune/info',
      name: 'FortuneInfo',
      component: () => import('@/views/fortune/info')
    },
    {
      // 每日评论页
      path: '/fortune/comment',
      name: 'FortuneComment',
      component: () => import('@/views/fortune/comment')
    },
    {
      // 每日分享页
      path: '/fortune/share',
      name: 'FortuneShare',
      component: () => import('@/views/fortune/share')
    },
    {
      // 生辰变更页
      path: '/fortune/change',
      name: 'FortuneChange',
      component: () => import('@/views/fortune/change')
    },
    // ------------四柱五行--------------------
    {
      // 四柱五行首页
      path: '/fivetools/home',
      name: 'FivetoolsHome',
      component: () => import('@/views/fivetools/home')
    },
    {
      // 四柱五行结果页
      path: '/fivetools/result',
      name: 'FivetoolsResult',
      component: () => import('@/views/fivetools/result')
    },
    {
      // 四柱五行评论
      path: '/fivetools/comment',
      name: 'FivetoolsComment',
      component: () => import('@/views/fivetools/comment')
    },
    {
      // 四柱五行排盘
      path: '/fivetools/plate',
      name: 'FivetoolsPlate',
      component: () => import('@/views/fivetools/plate')
    },
    {
      // 四柱五行排盘暂无数据
      path: '/fivetools/change',
      name: 'FivetoolsChange',
      component: () => import('@/views/fivetools/change')
    },
    // ------------帮助与客服--------------------
    {
      // 用户端首页
      path: '/help/home',
      name: 'HelpHome',
      component: () => import('@/views/help/home')
    },
    {
      // 老师端首页
      path: '/help/teacherHome',
      name: 'HelpTeacherHome',
      component: () => import('@/views/help/teacherHome'),
      meta: {
        keepAlive: true // 该路由会被缓存
      }
    },
    {
      // 老师端list页
      path: '/help/list',
      name: 'HelpList',
      component: () => import('@/views/help/list')
    },
    {
      // 用户端反馈页
      path: '/help/feedback',
      name: 'HelpFeedback',
      component: () => import('@/views/help/feedback')
    },
    {
      // 用户端反馈页
      path: '/help/toolFeedback',
      name: 'HelpToolFeedback',
      component: () => import('@/views/help/toolFeedback')
    },
    {
      // 用户端问题列表页
      path: '/help/issuesList',
      name: 'HelpIssuesList',
      component: () => import('@/views/help/issuesList')
    },
    {
      // 用户端问题详情
      path: '/help/issuesDetail',
      name: 'issuesDetail',
      component: () => import('@/views/help/issuesDetail')
    },
    {
      // 用户端评论列表页
      path: '/help/commentList',
      name: 'HelpCommentList',
      component: () => import('@/views/help/commentList')
    },
    // ----------活动路径---------------/
    {
      // 每日运势首页
      path: '/active/haveLuck',
      name: 'haveLuck',
      component: () => import('@/views/active/haveLuck')
    },
    // ---------个人中心-优惠劵----------
    {
      // 优惠劵首页
      path: '/coupon/coupon',
      name: 'coupon',
      component: () => import('@/views/coupon/coupon')
    },
    {
      // 用卷规则
      path: '/coupon/usedetail',
      name: 'couponUsedetail',
      component: () => import('@/views/coupon/usedetail')
    },
    {
      // 不可以优惠劵
      path: '/coupon/invalid',
      name: 'couponInvalid',
      component: () => import('@/views/coupon/invalid')
    },
    {
      // 领卷中心
      path: '/coupon/colla',
      name: 'couponColla',
      component: () => import('@/views/coupon/colla')
    },
    // -----------个人中心-我的商品----------
    {
      // 我的商品
      path: '/shop/order',
      name: 'shopOrder',
      component: () => import('@/views/shop/order')
    },
    {
      // 订单列表
      path: '/shop/order1',
      name: 'shopOrder1',
      component: () => import('@/views/shop/order1')
    },
    {
      // 订单详情
      path: '/shop/details',
      name: 'shopDetails',
      component: () => import('@/views/shop/details')
    },
    // ----------------个人中心-商城--------------
    {
      // 首页
      path: '/shopping/mall',
      name: 'shoppingMall',
      component: () => import('@/views/shopping/mall')
    },
    {
      // 商品分类
      path: '/shopping/list',
      name: 'shoppingList',
      component: () => import('@/views/shopping/list')
    },
    {
      // 专题
      path: '/shopping/special',
      name: 'shoppingSpecial',
      component: () => import('@/views/shopping/special')
    },
    {
      // 老师专题分类 老师说
      path: '/shopping/classification',
      name: 'shoppingClassification',
      component: () => import('@/views/shopping/classification')
    },
    {
      // 老师专题分类 老师推荐
      path: '/shopping/classtuijian',
      name: 'shoppingClasstuijian',
      component: () => import('@/views/shopping/classtuijian')
    },
    {
      // 老师说详情
      path: '/shopping/details',
      name: 'shoppingDetails',
      component: () => import('@/views/shopping/details')
    },
    {
      // 买家秀详情
      path: '/shopping/maijia',
      name: 'shoppingMaijia',
      component: () => import('@/views/shopping/maijia')
    },
    {
      // 搜索
      path: '/shopping/search',
      name: 'shoppingSearch',
      component: () => import('@/views/shopping/search')
    },
    {
      // 搜索结果页
      path: '/shopping/result',
      name: 'shoppingResult',
      component: () => import('@/views/shopping/result')
    },
    {
      // 购物车
      path: '/shopping/cart',
      name: 'shoppingCart',
      component: () => import('@/views/shopping/cart')
    },
    {
      // 商城支付成功
      path: '/shopping/success',
      name: 'shoppingSuccess',
      component: () => import('@/views/shopping/success')
    },
    {
      // 三笙隽详情页
      path: '/shopping/sansheng',
      name: 'shoppingSansheng',
      component: () => import('@/views/shopping/sansheng')
    },
    {
      // 商品情页
      path: '/shopping/shopdetail',
      name: 'shoppingShopdetail',
      component: () => import('@/views/shopping/shopdetail')
    },
    {
      // 订单情页
      path: '/shopping/orderdetail',
      name: 'shoppingOrderdetail',
      component: () => import('@/views/shopping/orderdetail')
    },
    {
      // 全部评价
      path: '/shopping/evaluate',
      name: 'shoppingEvaluate',
      component: () => import('@/views/shopping/evaluate')
    },
    {
      //
      path: '/shopping/shopListDatail',
      name: 'shoppingShopListDatail',
      component: () => import('@/views/shopping/shopListDatail')
    },
    /*************************************************/
    {
      //
      path: '/cece/index',
      name: 'Cece',
      component: () => import('@/views/cece/index')
    },
    {
      //
      path: '/cece/pocket',
      name: 'pocket',
      component: () => import('@/views/cece/pocket')
    },
    {
      //
      path: '/cece/downLoad',
      name: 'downLoad',
      component: () => import('@/views/cece/downLoad')
    },
    {
      path: '/cece/indexHome',
      name: 'indexHome',
      component: () => import('@/views/cece/indexHome')
    },
    /*************************************************/
    {
      // 全部评论
      path: '/shopping/discuss',
      name: 'shoppingDiscuss',
      component: () => import('@/views/shopping/discuss')
    },
    {
      // 个人中心
      path: '/shopping/member',
      name: 'shoppingMember',
      component: () => import('@/views/shopping/member')
    },
    {
      // 我的订单--暂无用上
      path: '/shopping/order',
      name: 'shoppingOrder',
      component: () => import('@/views/shopping/order')
    },
    {
      // 评价
      path: '/shopping/appraise',
      name: 'shoppingAppraiser',
      component: () => import('@/views/shopping/appraise')
    },
    {
      // 评价详情
      path: '/shopping/appraiseDateil',
      name: 'shoppingAppraiseDateil',
      component: () => import('@/views/shopping/appraiseDateil')
    },
    {
      // 评价成功
      path: '/shopping/secc',
      name: 'shoppingSecc',
      component: () => import('@/views/shopping/secc')
    },
    // ----------------个人中心-我的收货地址--------------
    {
      // 我的收货地址
      path: '/shopping/site',
      name: 'shoppingSite',
      component: () => import('@/views/shopping/site')
    },
    {
      // 编辑收货地址
      path: '/shopping/siteEdit',
      name: 'shoppingSiteEdit',
      component: () => import('@/views/shopping/siteEdit')
    },
    // ----------------收银台--------------
    {
      // 收银台
      path: '/cashier/checkstand',
      name: 'cashierCheckstand',
      component: () => import('@/views/cashier/checkstand')
    },
    {
      // 微信支付跳转支付宝中转页面
      path: '/cashier/alipay',
      name: 'cashierAlipay',
      component: () => import('@/views/cashier/alipay')
    },
    {
      // 通用支付成功
      path: '/cashier/paysuccess',
      name: 'cashierPaysuccess',
      component: () => import('@/views/cashier/paysuccess')
    },
    {
      // 全民赚钱支付 --统一在cashier路径下面
      path: '/cashier/bigShopPayment',
      name: 'cashierBigShopPayment',
      component: () => import('@/views/cashier/bigShopPayment')
    },
    {
      // 测币充值支付 --统一在cashier路径下面
      path: '/cashier/recharge',
      name: 'cashierRecharge',
      component: () => import('@/views/cashier/recharge')
    },
    {
      // 黑卡充值--统一在cashier路径下面
      path: '/cashier/cardPay',
      name: 'cashierCardPay',
      component: () => import('@/views/cashier/cardPay')
    },
    {
      //话题讨论购买商品
      path: '/cashier/discussPay',
      name: 'cashierDiscussPay',
      component: () => import('@/views/cashier/discussPay')
    },
    {
      //我的测币-支付
      path: '/cashier/measurement',
      name: 'cashierMeasurement',
      component: () => import('@/views/cashier/measurement')
    },
    // -------------测币中心------------------
    {
      // 我的测币--暂无无用
      path: '/credit/measurement',
      name: 'creditMeasurement',
      component: () => import('@/views/credit/measurement')
    },
    {
      // 测币明细
      path: '/credit/integral',
      name: 'creditIntegral',
      component: () => import('@/views/credit/integral')
    },
    {
      // 测币充值
      path: '/credit/recharge',
      name: 'creditRecharge',
      component: () => import('@/views/credit/recharge')
    },
    // -------------送礼首选------------------
    {
      // 送礼首选-首页
      path: '/my/giveGifts',
      name: 'myGiveGifts',
      component: () => import('@/views/my/giveGifts')
    },
    {
      // 送礼首选-更多老师
      path: '/my/givemore',
      name: 'myGiveMore',
      component: () => import('@/views/my/givemore')
    },
    {
      // 送礼首选-确定订单
      path: '/my/order',
      name: 'myOrder',
      component: () => import('@/views/my/order')
    },
    {
      // 送礼首选-用卷送卷
      path: '/my/buycouponrule',
      name: 'myBuycouponrule',
      component: () => import('@/views/my/buycouponrule')
    },
    {
      // 送礼首选-支付成功
      path: '/my/sess',
      name: 'mySess',
      component: () => import('@/views/my/sess')
    },
    // -------------个人中心-消息------------------
    {
      // -消息首页
      path: '/my/notice',
      name: 'myNotice',
      component: () => import('@/views/my/notice')
    },
    {
      // -系统通知
      path: '/my/systemnotice',
      name: 'mysystemNotice',
      component: () => import('@/views/my/systemnotice')
    },
    {
      // -活动公告
      path: '/my/activenotice',
      name: 'myActivenotice',
      component: () => import('@/views/my/activenotice')
    },
    {
      // -互动消息
      path: '/my/interactivenotice',
      name: 'myInteractivenotice',
      component: () => import('@/views/my/interactivenotice')
    },
    {
      // -老师叮嘱
      path: '/my/getuserlist',
      name: 'myGetuserlist',
      component: () => import('@/views/my/getuserlist')
    },
    {
      // -老师叮嘱详情
      path: '/my/getuserDateil',
      name: 'myGetuserDateil',
      component: () => import('@/views/my/getuserDateil')
    },
    // --------------------我的关注---------------------
    {
      // -我的关注
      path: '/my/collect',
      name: 'myCollect',
      component: () => import('@/views/my/collect')
    },
    // ------------------------------------------
    {
      // -
      path: '/sell/home',
      name: 'sellHome',
      component: () => import('@/views/sell/home')
    },
    //  --------------------我的互动----------------------
    {
      // 我的评论与赞
      path: '/my/interactive',
      name: 'myInteractive',
      component: () => import('@/views/my/interactive')
    },
    {
      // 收到的评论与赞
      path: '/my/interInex',
      name: 'myInterInex',
      component: () => import('@/views/my/interInex')
    },
    //  --------------------我的黑卡会员----------------------
    {
      // 黑卡首页
      path: '/my/cardIndex',
      name: 'myCardIndex',
      component: () => import('@/views/my/cardIndex')
    },
    {
      // 黑卡节省明细
      path: '/my/cardBenefit',
      name: 'myCardBenefit',
      component: () => import('@/views/my/cardBenefit')
    },
    {
      // 黑卡黑卡福利
      path: '/my/cardWelfare',
      name: 'myCardWelfare',
      component: () => import('@/views/my/cardWelfare')
    },
    {
      // 黑卡我的经验
      path: '/my/cardExperience',
      name: 'myExperience',
      component: () => import('@/views/my/cardExperience')
    },
    {
      // 黑卡黑卡会员特权
      path: '/my/cardPrivilege',
      name: 'myCardPrivilege',
      component: () => import('@/views/my/cardPrivilege')
    },
    {
      // 黑卡充值
      path: '/my/cardPay',
      name: 'myCardPay',
      component: () => import('@/views/my/cardPay')
    },
    {
      // 黑卡充值成功页面
      path: '/my/cradPaysuccess',
      name: 'myCradPaysuccess',
      component: () => import('@/views/my/cradPaysuccess')
    },
    {
      // 黑卡会员详细规则
      path: '/my/cradRule',
      name: 'myCradRule',
      component: () => import('@/views/my/cradRule')
    },
    //  --------------------直播----------------------
    {
      // 直播回放
      path: '/live/watchlist',
      name: 'myWatchlist',
      component: () => import('@/views/live/watchlist')
    },
    //直播大厅
    {
      path: '/live/home',
      name: 'liveIndex',
      component: () => import('@/views/live/home')
    },
    //关注的人
    {
      path: '/live/foll',
      name: 'liveFoll',
      component: () => import('@/views/live/foll')
    },
    //直播搜索
    {
      path: '/live/search',
      name: 'liveSearch',
      component: () => import('@/views/live/search')
    },
    {
      //名师讲堂
      path: '/live/lecture',
      name: 'liveLecture',
      component: () => import('@/views/live/lecture')
    },
    {
      //老师直播回放列表
      path: '/live/playback',
      name: 'livePlayback',
      component: () => import('@/views/live/playback')
    },
    {
      //精品课程
      path: '/live/bestteach',
      name: 'liveBestteach',
      component: () => import('@/views/live/bestteach')
    },
    {
      //黑卡免费课
      path: '/live/cardteach',
      name: 'liveCardteach',
      component: () => import('@/views/live/cardteach')
    },
    {
      //课程详情
      path: '/live/classdetail',
      name: 'classDetail',
      component: () => import('@/views/live/classdetail')
    },
    {
      //课程支付成功
      path: '/live/classpaysuccess',
      name: 'classPaysuccess',
      component: () => import('@/views/live/classpaysuccess')
    },
    //  --------------------我的闪测----------------------
    {
      // 我的闪测
      path: '/my/answer',
      name: 'myAnswer',
      component: () => import('@/views/my/answer')
    },
    //  --------------------我的咨询----------------------
    {
      // 我的咨询-首页
      path: '/my/consult',
      name: 'myConsult',
      component: () => import('@/views/my/consult')
    },
    {
      // 我的咨询-取消订单
      path: '/my/consultCancel',
      name: 'myConsultCancel',
      component: () => import('@/views/my/consultCancel')
    },
    //  --------------------我的课程----------------------
    {
      // 首页
      path: '/courses/home',
      name: 'coursesHome',
      component: () => import('@/views/courses/home')
    },
    //  --------------------设置----------------------
    {
      // 设置首页
      path: '/my/setInfo',
      name: 'mySetInfo',
      component: () => import('@/views/my/setInfo')
    },
    {
      // 换绑手机号
      path: '/my/setBing',
      name: 'mySetBing',
      component: () => import('@/views/my/setBing')
    },
    {
      // 换绑手机号
      path: '/my/setPhone',
      name: 'mySetPhone',
      component: () => import('@/views/my/setPhone')
    },
    {
      // 修改换绑手机号
      path: '/my/setEditPhone',
      name: 'mySetEditPhone',
      component: () => import('@/views/my/setEditPhone')
    },
    {
      // 国家区号
      path: '/my/setCountry',
      name: 'mySetCountry',
      component: () => import('@/views/my/setCountry')
    },
    {
      // 实名认证
      path: '/my/setCard',
      name: 'mySetCard',
      component: () => import('@/views/my/setCard')
    },
    {
      // 实名认证审核页面
      path: '/my/setAudit',
      name: 'mySetAudit',
      component: () => import('@/views/my/setAudit')
    },
    {
      // 生成信息列表
      path: '/my/setBirthList',
      name: 'myBirthList',
      component: () => import('@/views/my/setBirthList')
    },
    {
      // 生成信息新增
      path: '/my/setBirthAdd',
      name: 'myBirthAdd',
      component: () => import('@/views/my/setBirthAdd')
    },
    {
      // 生成信息编辑
      path: '/my/setBirthEdit',
      name: 'myBirthEdit',
      component: () => import('@/views/my/setBirthEdit')
    },
    // --------------------------- 我的---------------------
    {
      // 首页
      path: '/my',
      name: 'my',
      component: () => import('@/views/my/index')
    },
    // **************三生石小工具**************
    {
      // 首页
      path: '/stone/home',
      name: 'stoneHome',
      meta: {
        keepAlive: false
      },
      component: () => import('@/views/stone/home')

    },
    {
      // 专属顾问
      path: '/stone/counselor',
      name: 'stoneCounselor',
      meta: {
        keepAlive: false
      },
      component: () => import('@/views/stone/counselor')
    },
    {
      // 查询订单
      path: '/stone/query',
      name: 'stoneQuery',
      component: () => import('@/views/stone/query')
    },
    // **************三生石小工具END**************
    {
      // 聊天
      path: '/dialog',
      name: 'dialog',
      component: () => import('@/views/dialog/index')
    },
    {
      // 老师聊天
      path: '/dialog/indexTeacher',
      name: 'dialogTeacher',
      component: () => import('@/views/dialog/indexTeacher')
    },
    {
      // 支付
      path: '/dialog/pay',
      name: 'dialogPay',
      component: () => import('@/views/dialog/pay')
    },
    {
      // 评价
      path: '/dialog/evaluate',
      name: 'dialogEvaluate',
      component: () => import('@/views/dialog/evaluate')
    },
    {
      // 查看评价
      path: '/dialog/lookEvaluate',
      name: 'dialogLookEvaluate',
      component: () => import('@/views/dialog/lookEvaluate')
    },
    {
      // 查看评价
      path: '/dialog/alterEvaluate',
      name: 'dialogAlterEvaluate',
      component: () => import('@/views/dialog/alterEvaluate')
    },
    {
      // 聊天与评论过渡页
      path: '/dialog/interim',
      name: 'dialogInterim',
      component: () => import('@/views/dialog/interim')
    },
    {
      // 评价后
      path: '/dialog/copy',
      name: 'dialogCopy',
      component: () => import('@/views/dialog/copy')
    },
    {
      // 新增常用语
      path: '/dialog/addLanguage',
      name: 'dialogAddLanguage',
      component: () => import('@/views/dialog/addLanguage')
    },
    {
      // 新增常用语
      path: '/dialog/updateLanguage',
      name: 'dialogUpdateLanguage',
      component: () => import('@/views/dialog/updateLanguage')
    },
    {
      // 编辑常用语
      path: '/dialog/alterLanguage',
      name: 'dialogAlterLanguage',
      component: () => import('@/views/dialog/alterLanguage')
    },
    {
      // 查看预约时间
      path: '/dialog/handler',
      name: 'dialogHandler',
      component: () => import('@/views/dialog/handler')
    },
    {
      // 查看预约时间
      path: '/dialog/shopsPay',
      name: 'dialogShopsPay',
      component: () => import('@/views/dialog/shopsPay')
    },
    /************全民赚钱make/sell**************/
    {
      path: '/make/sell',
      name: 'sell',
      component: () => import('@/views/make/sell'),
      children: [
        //首页
        {
          path: 'index',
          component: () => import('@/views/make/index')
        },
        //消息
        {
          path: 'message',
          component: () => import('@/views/make/message')
        },
        //会员等级
        {
          path: 'upgrade',
          component: () => import('@/views/make/upgrade')
        },
        //会员等级满额商品详情
        {
          path: "upgradeDateil",
          component: () => import('@/views/make/upgradeDateil')
        },
        //会员等级满额领取记录
        {
          path: "upgradeRecord",
          component: () => import('@/views/make/upgradeRecord')
        },
        //大咖礼包详情
        {
          path: "bigShotDateil",
          component: () => import('@/views/make/bigShotDateil')
        },
        //支付
        {
          path: "bigShopPayment",
          component: () => import('@/views/make/bigShopPayment')
        },
        //支付状态页面
        {
          path: "bigShopState",
          component: () => import('@/views/make/bigShopState')
        },
        //权益说明
        {
          path: "rights",
          component: () => import('@/views/make/rights')
        },
        //代理中心
        {
          path: "agency",
          component: () => import('@/views/make/agency')
        },
        //推广订单
        {
          path: "spread",
          component: () => import('@/views/make/spread')
        },
        //收支明细
        {
          path: "incomeState",
          component: () => import('@/views/make/incomeState')
        },
        //提现
        {
          path: "cashIndex",
          component: () => import('@/views/make/cashIndex')
        },
        //收款账户
        {
          path: "cashAccount",
          component: () => import('@/views/make/cashAccount')
        },
        //短信验证支付宝账号
        {
          path: "cashVerify",
          component: () => import('@/views/make/cashVerify')
        },
        //绑定支付宝账号
        {
          path: "cashAlipay",
          component: () => import('@/views/make/cashAlipay')
        },
        //提现状态
        {
          path: "cashState",
          component: () => import('@/views/make/cashState')
        },
        //佣金消费兑换
        {
          path: "incomeExchange",
          component: () => import('@/views/make/incomeExchange')
        },
        //榜单中心
        {
          path: "listCenter",
          component: () => import('@/views/make/listCenter')
        },
        //帮助中心
        {
          path: "helpIndex",
          component: () => import('@/views/make/helpIndex')
        },
        //帮助中心分类列表
        {
          path: "helpList",
          component: () => import('@/views/make/helpList')
        },
        //帮助中心分类详情
        {
          path: "helpDateil",
          component: () => import('@/views/make/helpDateil')
        },
        //邀请攻略
        {
          path: "yqStrategy",
          component: () => import('@/views/make/yqStrategy')
        },
        //推广海报
        {
          path: "posterIndex",
          component: () => import('@/views/make/posterIndex')
        },
        //推广规则
        {
          path: "posterRule",
          component: () => import('@/views/make/posterRule')
        },
        //培训中心
        {
          path: "trainIndex",
          component: () => import('@/views/make/trainIndex')
        },
        //培训中心详情
        {
          path: "trainDateil",
          component: () => import('@/views/make/trainDateil')
        },
        //素材库
        {
          path: "materialIndex",
          component: () => import('@/views/make/materialIndex')
        },
        //新人福利
        {
          path: "newWelfare",
          component: () => import('@/views/make/newWelfare')
        },
      ]
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js